const prefix = "[FILTERS]";

export default {
    // FETCH_SCHEDULER_DEFINITIONS_REQUEST: `${prefix} FETCH_SCHEDULER_DEFINITIONS_REQUEST`,
    // FETCH_SCHEDULER_DEFINITIONS_SUCCESS: `${prefix} FETCH_SCHEDULER_DEFINITIONS_SUCCESS`,
    // FETCH_SCHEDULER_DEFINITIONS_FAILED: `${prefix} FETCH_SCHEDULER_DEFINITIONS_FAILED`,
    FETCH_CREATIVE_MAPPINGS_FILTERS_REQUEST: `${prefix} FETCH_CREATIVE_MAPPINGS_FILTERS_REQUEST`,
    FETCH_CREATIVE_MAPPINGS_FILTERS_SUCCESS: `${prefix} FETCH_CREATIVE_MAPPINGS_FILTERS_SUCCESS`,
    FETCH_CREATIVE_MAPPINGS_FILTERS_FAILED: `${prefix} FETCH_CREATIVE_MAPPINGS_FILTERS_FAILED`,
    CLEAR_FILTER_FIELDS: `${prefix} CLEAR_FILTER_FIELDS`,
};
